import { render, staticRenderFns } from "./PublisherPaymentHistory.vue?vue&type=template&id=24e3d076&scoped=true"
import script from "./PublisherPaymentHistory.vue?vue&type=script&lang=js"
export * from "./PublisherPaymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3d076",
  null
  
)

export default component.exports